import { ElementType, Intent, ObjectPosition, TargetType } from "@mobility-item-page/utilities/client";
import usePulse from "../../../utils/pulse-tracking/usePulse.ts";

type Props = {
  mapHref: string;
  mapImage: string;
  hideAddressLink?: boolean;
};

const Location = ({ mapHref, mapImage, hideAddressLink }: Props) => {
  const { trackClick } = usePulse();

  const handleOnClick = () => {
    // Tracking event: CE_ev54
    trackClick({
      name: "Go to map",
      objectId: "CE_ev54",
      elementType: ElementType.Map,
      intent: Intent.Open,
      position: ObjectPosition.Map,
      target: {
        id: mapHref,
        type: TargetType.Page,
      },
    });
  };

  return (
    <>
      {hideAddressLink ? (
        <img src={mapImage} loading="lazy" alt="Kart" className="max-w-full rounded-8 mt-16" />
      ) : (
        <a onClick={handleOnClick} href={mapHref}>
          <img src={mapImage} loading="lazy" alt="Kart" className="max-w-full rounded-8 mt-16" />
        </a>
      )}
    </>
  );
};

export default Location;
